// Authentication
export const SET_LOGIN = 'SET_LOGIN';
export const SET_LOGOUT = 'SET_LOGOUT';
export const SET_AUTH_USER = 'SET_AUTH_USER';
export const SET_CURRENT_USER_ROLE = 'SET_CURRENT_USER_ROLE';

// Sidebar
export const DASHBOARD_SET_LEFT_SIDEBAR_EXPANDED = 'DASHBOARD_SET_LEFT_SIDEBAR_EXPANDED';
export const DASHBOARD_SET_RIGHT_SIDEBAR_CONTENT = 'DASHBOARD_SET_RIGHT_SIDEBAR_CONTENT';
export const DASHBOARD_OPEN_RIGHT_SIDEBAR = 'DASHBOARD_OPEN_RIGHT_SIDEBAR';
export const DASHBOARD_CLOSE_RIGHT_SIDEBAR = 'DASHBOARD_CLOSE_RIGHT_SIDEBAR';
export const DASHBOARD_OPEN_SETTINGS_MODAL = 'DASHBOARD_OPEN_SETTINGS_MODAL';
export const DASHBOARD_CLOSE_SETTINGS_MODAL = 'DASHBOARD_CLOSE_SETTINGS_MODAL';
export const DASHBOARD_NAVBAR_SHOW = 'DASHBOARD_NAVBAR_SHOW';
export const DASHBOARD_ACTIVE_USER = 'DASHBOARD_ACTIVE_USER';

export const SET_SEARCH = 'SET_SEARCH';

// ENTERPRISES
export const SET_ENTERPRISES = 'SET_COMPANIES';
export const SET_ENTERPRISE = 'SET_ENTERPRISE';
export const SET_EMPLOYEES = 'SET_EMPLOYEES';
export const SET_ENTERPRISE_SELECTED_NEW_EMPLOYEE = 'SET_ENTERPRISE_SELECTED_NEW_EMPLOYEE';
export const SET_ENTERPRISE_SELECTED_EMPLOYEE = 'SET_ENTERPRISE_SELECTED_EMPLOYEE';
export const SET_ENTERPRISE_BLOCK_EMPLOYEE_MODAL = 'SET_ENTERPRISE_BLOCK_EMPLOYEE_MODAL';
export const SET_ENTERPRISE_DETAILS_EMPLOYEE_MODAL = 'SET_ENTERPRISE_DETAILS_EMPLOYEE_MODAL';
export const SET_ENTERPRISE_EMPLOYEES_ARCHIVED_MODAL = 'SET_ENTERPRISE_EMPLOYEES_ARCHIVED_MODAL';

// PROPERTY

export const TOGGLE_ACTION_PLAN_DRAWER = 'TOGGLE_ACTION_PLAN_DRAWER';

// User Events
export const SET_USER_EVENTS = 'SET_USER_EVENTS';
export const SET_USER_EVENTS_LOADING = 'SET_USER_EVENTS_LOADING';

// User Properties
export const SET_USER_PROPERTIES = 'SET_USER_PROPERTIES';

// User Actions Plans
export const SET_USER_ACTION_PLANS = 'SET_USER_ACTION_PLANS';
export const SET_USER_ACTION_PLANS_LOADING = 'SET_USER_ACTION_PLANS_LOADING';
export const SET_CHANGE_HOLDER_PROPERTY_MODAL = 'SET_CHANGE_HOLDER_PROPERTY_MODAL';
export const SET_USER_ARCHIVE_ACTION_PLANS = 'SET_USER_ARCHIVE_ACTION_PLANS';
